import { createTheme } from "@mui/material/styles";

const themeTemp = createTheme();
const gray = themeTemp.palette.augmentColor({
    color: { main: "#3E3E3F", contrastText: "#FFF" },
    name: "gray",
});

const gray2 = themeTemp.palette.augmentColor({
    color: {
        main: themeTemp.palette.grey[600],
        contrastText: "#fff",
    },
    name: "gray2",
});

const white2 = themeTemp.palette.augmentColor({
    color: {
        main: "#fff",
        contrastText: "#000",
    },
    name: "white2",
});

const theme = createTheme({
    breakpoints: {
        values: {
            ...themeTemp.breakpoints.values,
            xxs: 340,
            mobile: 480,
            tablet: 745,
            laptop: 1024,
            laptopL: 1232,
            desktop: 1440,
        },
    },
    palette: {
        primary: {
            main: "#36845B",
        },
        secondary: {
            main: "#3498DB",
        },
        gray,
        gray2,
        white2,
    },
    transitions: {
        // So we have `transition: none;` everywhere
        create: () => "none",
    },
    typography: {
        fontFamily: [
            '"Source Sans 3"',
            '"Roboto"',
            '"Helvetica Neue"',
            "Arial",
            "sans-serif",
        ].join(","),
    },
});
theme.sideNav = {
    background: gray.main,
    color: gray.contrastText,
    selectedBg: gray.light,
    width: 270,
};

export default theme;
